export interface EventFilterParams {
    deviceId?: number;
    typeId?: number;
    startDate?: Date;
    endDate?: Date;
}

export const filterParamToString = (filter: EventFilterParams, optionName: string): string => {
    if (typeof filter[optionName] === 'undefined') {
        return null;
    }
    if (filter[optionName] instanceof Date) {
        return formatDate(filter[optionName]);
    }
    return filter[optionName].toString();
};

const formatDate = (d: Date): string => {
    const year = d.getFullYear();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
};
